import React, { useEffect, useState } from 'react';
import LoginChangePassword from '../Components/Login/ui/LoginChangePassword';
import LoginForgotPassword from '../Components/Login/ui/LoginForgotPassword';
import LoginForm from '../Components/Login/ui/LoginForm';
import TermsAndConditions from '../Components/Login/ui/TermsAndConditions';
import LoginSelectOrganization from '../Components/Login/ui/LoginSelectOrganization';
import { useSelector } from 'react-redux';
import { LoginModes } from '../constants';
import { getTitle } from '../Components/Login/ui/LoginHelper';

const LoginContainer = ({ hideH1 }) => {
  const { loginMode, error, terms } = useSelector((state) => state.login);

  return (
    <>
      {!hideH1 && <h1 className="login-page__title">{getTitle(loginMode)}</h1>}
      {error && <div className="login__error">{error}</div>}
      {loginMode == LoginModes.Login && <LoginForm />}
      {loginMode == LoginModes.Terms && <TermsAndConditions terms={terms} />}
      {loginMode == LoginModes.SelectOrganization && (
        <LoginSelectOrganization />
      )}
      {loginMode == LoginModes.ChangePassword && <LoginChangePassword />}
      {loginMode == LoginModes.ForgotPassword && <LoginForgotPassword />}
    </>
  );
};

export default LoginContainer;
